import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from './theme/ThemeProvider';
import { App } from './App';
import { bridgedPath } from './auth/hashBridge';
import './styles/global.css';

const bridged = bridgedPath(import.meta.env.BASE_URL, location.pathname, location.hash);
if (bridged) history.replaceState(null, '', bridged);

const root = document.getElementById('root');
if (!root) throw new Error('Élément #root introuvable');

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
);
